import { render, staticRenderFns } from "./ItemCollectionLayout.vue?vue&type=template&id=6f3da734&scoped=true"
import script from "./ItemCollectionLayout.vue?vue&type=script&lang=js"
export * from "./ItemCollectionLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3da734",
  null
  
)

export default component.exports